// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktop":"zj_a","AdSlotBranding__mobile":"zj_b"};